<template>
  <b-row>
    <b-col lg="12">
      <CompanyLeadsTable/>
    </b-col>
  </b-row>
</template>
<script>
import CompanyLeadsTable from "./Components/CompanyLeadsTable.vue";

export default {
  name: "CompanyLeads",
  components: {
    CompanyLeadsTable
  },
  mounted() {
    core.index();
  },
};
</script>
